<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.6663 11.16V3.11336C14.6663 2.31336 14.013 1.72002 13.2197 1.78669H13.1797C11.7797 1.90669 9.65301 2.62002 8.46634 3.36669L8.35301 3.44002C8.15967 3.56002 7.83967 3.56002 7.64634 3.44002L7.47967 3.34002C6.29301 2.60002 4.17301 1.89336 2.77301 1.78002C1.97967 1.71336 1.33301 2.31336 1.33301 3.10669V11.16C1.33301 11.8 1.85301 12.4 2.49301 12.48L2.68634 12.5067C4.13301 12.7 6.36634 13.4334 7.64634 14.1334L7.67301 14.1467C7.85301 14.2467 8.13967 14.2467 8.31301 14.1467C9.59301 13.44 11.833 12.7 13.2863 12.5067L13.5063 12.48C14.1463 12.4 14.6663 11.8 14.6663 11.16Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 3.65997V13.66"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.16699 5.65997H3.66699"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66699 7.65997H3.66699"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "tmc-icon",
};
</script>

<style lang="scss" scoped></style>
